// Module
var code = "<div ng-style=\"{ 'width' : '100%', 'height': '100%'}\" ng-if=\"uiVer=='v2'\" ng-include src=\"'app/overview/overview-embed.html'\"></div> <div ng-if=\"orgTemplate=='store'\" ng-include src=\"'app/overview/store-overview.html'\"></div> <div ng-if=\"orgTemplate=='storegroup'\" ng-include src=\"'app/overview/storegroup-overview.html'\"></div> ";
// Exports
export default code;